import React from 'react';

const StatusBadge = ({ status }) => {
    const statusConfig = {
        pending: { label: 'Pending', color: 'bg-yellow-100 text-yellow-800' },
        confirmed: { label: 'Confirmed', color: 'bg-blue-100 text-blue-800' },
        processing: { label: 'Processing', color: 'bg-purple-100 text-purple-800' },
        packed: { label: 'Packed', color: 'bg-indigo-100 text-indigo-800' },
        shipped: { label: 'Shipped', color: 'bg-cyan-100 text-cyan-800' },
        out_for_delivery: { label: 'Out for Delivery', color: 'bg-teal-100 text-teal-800' },
        delivered: { label: 'Delivered', color: 'bg-green-100 text-green-800' },
        cancelled: { label: 'Cancelled', color: 'bg-red-100 text-red-800' },
        returned: { label: 'Returned', color: 'bg-orange-100 text-orange-800' },
    };

    const normalizedStatus = status?.toLowerCase().replace(/\s+/g, '_');
    const config = statusConfig[normalizedStatus] || { label: status || 'Unknown', color: 'bg-gray-100 text-gray-800' };

    return (
        <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${config.color}`}>
            {config.label}
        </span>
    );
};

export default StatusBadge;
